module.exports = __webpack_public_path__ + "img/Funkgruppe.f39f66d6.svg";